"use client"

import axios from "axios"
import { useEffect, useState } from "react"
import { NotificationManager } from "react-notifications"
import SearchDropdown from "../../../components/Dropdowns/SearchDropdown"
import OptionalOption from "../../../components/FilterComponents/OptionalOption"
import useAuth from "../../../hooks/useAuth"
import { BASE_URL } from "../../../utils/Element"

const ContractCloseFilterData = ({ filterData, onSetFilterData, onCallApiAgain , from }) => {
  const [config] = useAuth()

  const [currentPhaseOptions, setCurrentPhaseOptions] = useState([])
  const [nextActionOptions, setNextActionOptions] = useState([])

  const [phaseValue, setPhaseValue] = useState({
    current_phase: "",
    next_action: "",
  })

  // ✅ Fetch suggestions
  const fetchContractSuggestions = (inputValue, fieldType) => {
    axios
      .get(
        `${BASE_URL}/get-datalisting?list=contract_to_close&search=${inputValue}&field=${fieldType}`,
        config
      )
      .then((res) => {
        const data = res?.data?.contract_to_close || {}

        const options = Object.entries(data).map(([key, value]) => ({
          value: key,
          label: value,
        }))

        if (fieldType === "current_phase") {
          setCurrentPhaseOptions(options)
        } else if (fieldType === "next_action") {
          setNextActionOptions(options)
        }
      })
      .catch((err) => {
        if (
          err.response?.data?.message &&
          err.response?.data?.message !== "Too Many Attempts."
        ) {
          NotificationManager.error(err.response?.data?.message)
        }
      })
  }

  // ✅ Initial load
  useEffect(() => {
    fetchContractSuggestions("", "current_phase")
    fetchContractSuggestions("", "next_action")
  }, [])

  // ✅ Sync UI with filterData
  useEffect(() => {
    if (filterData) {
      setPhaseValue({
        current_phase: filterData?.current_phase_label || "",
        next_action: filterData?.next_action_label || "",
      })
    }
  }, [filterData])

  // ✅ FIXED handleSelect (IMPORTANT)
  const handleSelect = (option, fieldName) => {
    if (!option) return;

    onSetFilterData((prev) => {
      if (!option.value) {
        const updated = { ...prev };
        delete updated[fieldName];
        delete updated[`${fieldName}_label`];
        return updated;
      }

      return {
        ...prev,
        [fieldName]: option.value,
        [`${fieldName}_label`]: option.label,
      };
    });

    // ✅ THIS LINE FIXES YOUR ISSUE
    if (onCallApiAgain) {
      onCallApiAgain(); // closes filter / refreshes data
    }

    // update UI
    setPhaseValue((prev) => ({
      ...prev,
      [fieldName]: option.label,
    }));
  };

  // ✅ Archive mode
  if (from === "contractclosearchive") {
    return (
      <div>
        <p className="head-4 dark-H">Date Range</p>

        <OptionalOption
          activeTab="date"
          onSetLastDate={(value) =>
            onSetFilterData((prev) => ({ ...prev, count: value }))
          }
          date={filterData?.count}
          onSetDateRange1={(value) =>
            onSetFilterData((prev) => ({ ...prev, start_count: value }))
          }
          date2={filterData?.start_count}
          onSetDateRange2={(value) =>
            onSetFilterData((prev) => ({ ...prev, end_count: value }))
          }
          date3={filterData?.end_count}
          onClear={() => {
            onSetFilterData((prev) => ({
              ...prev,
              count: "",
              start_count: "",
              end_count: "",
            }))
          }}
        />
      </div>
    )
  }

  return (
    <>
      {/* Current Phase */}
      <div className="mt-4">
        <label className="dark-H head-4 mb-2">Current Phase</label>
        <SearchDropdown
          name="current_phase"
          text={phaseValue.current_phase}
          placeholder="Write Current Phase Here"
          options={currentPhaseOptions}
          fetchSuggestions={(val) =>
            fetchContractSuggestions(val, "current_phase")
          }
          onSetOptions={setCurrentPhaseOptions}
          handleSelect={(option) =>
            handleSelect(option, "current_phase")
          }
        />
      </div>

      {/* Next Action */}
      <div className="mt-4">
        <label className="dark-H head-4 mb-2">Next Action</label>
        <SearchDropdown
          name="next_action"
          text={phaseValue.next_action}
          placeholder="Write Next Action Here"
          options={nextActionOptions}
          fetchSuggestions={(val) =>
            fetchContractSuggestions(val, "next_action")
          }
          onSetOptions={setNextActionOptions}
          handleSelect={(option) =>
            handleSelect(option, "next_action")
          }
        />
      </div>
    </>
  )
}

export default ContractCloseFilterData